import { db, inspectArchiveHealth } from "./db";

export type StorageHealthStatus = "healthy" | "warning" | "stalled" | "error";
export interface StorageHealthResult {
  status: StorageHealthStatus;
  durationMs: number;
  error?: string;
  archive?: Awaited<ReturnType<typeof inspectArchiveHealth>>;
}

const TIMEOUT_MS = 2500;

export async function probeStorageResponsiveness(): Promise<StorageHealthResult> {
  const startedAt = performance.now();
  try {
    const archive = await Promise.race([
      inspectArchiveHealth(),
      new Promise<never>((_, reject) => window.setTimeout(() => reject(new Error("IndexedDB 响应超时")), TIMEOUT_MS)),
    ]);
    return { status: archive.status === "healthy" ? "healthy" : archive.status === "warning" ? "warning" : "error", durationMs: performance.now() - startedAt, archive };
  } catch (error) {
    return { status: error instanceof Error && error.message.includes("超时") ? "stalled" : "error", durationMs: performance.now() - startedAt, error: error instanceof Error ? error.message : String(error) };
  }
}

export async function estimateStorageUsage() {
  try {
    const estimate = await navigator.storage?.estimate?.();
    return { usage: estimate?.usage ?? 0, quota: estimate?.quota ?? 0, persistent: await navigator.storage?.persisted?.() ?? false, databaseOpen: db.isOpen() };
  } catch {
    return { usage: 0, quota: 0, persistent: false, databaseOpen: db.isOpen() };
  }
}
